<div class="pending-card">
  <span class="pending-icon"><i class="pi pi-clock" aria-hidden="true"></i></span>
  <h1 data-clarity-unmask="true">Konto oczekuje na nadanie uprawnień</h1>
  <p>
    Twoje konto zostało utworzone, a adres e-mail potwierdzony. Nie masz jeszcze dostępu do żadnej
    sekcji panelu.
  </p>
  <p>
    Jeśli zarejestrowałeś ośrodek szkolenia kierowców, operator platformy musi najpierw zaakceptować
    zgłoszenie. Po akceptacji <strong>zaloguj się ponownie</strong> - uprawnienia są nadawane przy
    logowaniu.
  </p>

  <p-button label="Wyloguj się" icon="pi pi-sign-out" [outlined]="true" routerLink="/auth/logout" data-clarity-unmask="true"></p-button>
</div>
